import { ReactElement } from 'react';
import { GridFilterForm } from '@mui/x-data-grid-pro';
import { noop } from 'shared/utils/function';
import type { FilterRowFormProps } from './types';

/** The line draws the remove button and the AND / OR before the form, as MUI's panel does. */
const HIDDEN_DELETE_ICON_PROPS = { sx: { display: 'none' } };

/** One filter row: MUI's form with the column, the column's operators and value input. */
export function FilterRowForm({
  row,
  filterFormProps,
  columnsSort,
  onChange,
  onRemove,
}: FilterRowFormProps): ReactElement {
  return (
    <GridFilterForm
      item={row}
      applyFilterChanges={onChange}
      deleteFilter={onRemove}
      hasMultipleFilters={false}
      applyMultiFilterOperatorChanges={noop}
      columnsSort={columnsSort}
      {...filterFormProps}
      deleteIconProps={HIDDEN_DELETE_ICON_PROPS}
    />
  );
}
